<script lang="ts">
	let textareaEl: HTMLTextAreaElement | null = null
	const maxLines = 5

	interface Props {
		value?: string
		placeholder?: string
		disabled?: boolean
		readonly?: boolean
		onSend?: (message: string) => void
	}

	let {
		placeholder = 'Type a message...',
		disabled = false,
		readonly = false,
		onSend,
		value = $bindable('')
	}: Props = $props()

	function adjustHeight() {
		if (!textareaEl) return

		textareaEl.style.height = 'auto'

		const lineHeight = parseFloat(getComputedStyle(textareaEl).lineHeight)
		const maxHeight = lineHeight * maxLines

		const newHeight = Math.min(textareaEl.scrollHeight, maxHeight)

		textareaEl.style.height = `${newHeight}px`
		textareaEl.style.overflowY = textareaEl.scrollHeight > maxHeight ? 'auto' : 'hidden'
	}

	function handleSend() {
		if (!value.trim()) return
		onSend?.(value.trim())
	}

	export function focus() {
		textareaEl?.focus()
	}

	$effect(() => {
		adjustHeight()
	})

	$effect(() => {
		value
		adjustHeight()
	})
</script>

<div class="textarea-container">
	<textarea
		bind:this={textareaEl}
		class="auto-textarea"
		{placeholder}
		{disabled}
		{readonly}
		{value}
		oninput={(e) => (value = (e.target as HTMLTextAreaElement).value)}
		onkeydown={(e) => {
			if (e.key === 'Enter' && !e.shiftKey) {
				e.preventDefault()
				handleSend()
			}
		}}
		rows="1"
	></textarea>
</div>

<style lang="postcss">
	.textarea-container {
		@apply text-gray-600 flex gap-2 bg-white border-none w-full px-0;
	}

	.auto-textarea {
		@apply flex-1 resize-none text-base leading-5 px-0 py-0 outline-none overflow-hidden;
		transition: height 0.15s ease;
	}

	.auto-textarea:focus {
		@apply border-blue-400;
	}

	.auto-textarea:disabled {
		@apply bg-gray-100 text-gray-400 cursor-not-allowed;
	}
</style>
